// Delious APIデータを加工する共通処理

export namespace DeliousApiUtil {

    // セット商品配下のセレクション一覧取得
    // 単数 → 複数
    export function setItemToSelections(items: Delious.SetItem): Delious.Selection[] {
        // todo セット対応時に変換関数作る
        console.error("未実装")
        return [];
    }

    export function setItemsToSelections(items: Delious.SetItem): Delious.Selection[] {
        console.error("未実装")
        return [];
    }

    // 商品配下のオプショングループ取得
    // 複数 → 複数
    export function itemsToCondimentGroups(items: Delious.Item[]): Delious.CondimentGroup[] {
        if (!Array.isArray(items))
            return [];

        const result: Delious.CondimentGroup[] = [];
        for (let i = 0; i < items.length; i++) {
            const condimentGroups = itemToCondimentGroups(items[i]);
            for (let j = 0; j < condimentGroups.length; j++) {
                result.push(condimentGroups[j]);
            }
        }
        return result;
    }

    // 商品配下のオプショングループ取得
    // 単体 → 複数
    export function itemToCondimentGroups(item: Delious.Item): Delious.CondimentGroup[] {
        if (!item)
            return [];

        const condimentGroup = item.condiment_group;
        if (!condimentGroup)
            return [];

        if (condimentGroup.object_type == "condiment_group")
            return [condimentGroup as Delious.CondimentGroup];

        if (condimentGroup.object_type == "condiment_set")
            return (condimentGroup as Delious.CondimentSet).condiment_group_list;

        return [];
    }

    // オプショングループ配下のオプション商品取得
    // 複数 → 複数
    export function condimentGroupsToCondimentItems(condimentGroups: Delious.CondimentGroup[]): Delious.CondimentItem[] {
        if (!Array.isArray(condimentGroups))
            return [];

        let result: Delious.CondimentItem[] = [];
        for (let i = 0; i < condimentGroups.length; i++) {
            const condimentItems = condimentGroupToCondimentItems(condimentGroups[i]);
            for (let j = 0; j < condimentItems.length; j++) {
                result.push(condimentItems[j]);
            }
        }

        // 重複排除
        const itemIds = result.map(v => v.plu_no);
        result = result.filter((v, i) => itemIds.indexOf(v.plu_no) == i)

        return result;
    }

    // オプショングループ配下のオプション商品取得
    // 単数 → 複数
    export function condimentGroupToCondimentItems(condimentGroup: Delious.CondimentGroup): Delious.CondimentItem[] {
        if (!condimentGroup)
            return [];

        if (!Array.isArray(condimentGroup.condiment_list))
            return [];

        return condimentGroup.condiment_list;
    }
}
